import { gql } from '@apollo/client';
import { SMART_IMPORT_FIELDS } from './smartImportQuery';

export const StandardImportQueryName = 'StandardImport';

export const STANDARD_IMPORT_QUERY = gql`
  query ${StandardImportQueryName}($id: ID!) {
    standardImport(id: $id) {
      ...SmartImportFields
    }
  }
  ${SMART_IMPORT_FIELDS}
`;
